<template>
  <div>
    <validation-observer ref="observer">
    <base-box v-if="cusInfoAllProps.typeO.legalYn === 'Y'"
              title="要保人法定代理人資料建置"
              style="margin-bottom:50px">
        <v-container grid-list-md>
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm12>
              <font color='red'>*原住民長姓名(指特殊字)、姓名/地址有難字及受監護宣告客戶皆需改採紙本進件。</font>
            </v-flex>
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>{{ idnLabel }}</template>
              </sub-header>
              <div class="d-flex">
              <div style="width: 100%;padding-top:5px">
              <b-text-field v-model="cusInfo.typeO.legcusIdn"
                            v-checker
                            :disabled="isPreview || idnReadOnlyO"
                            @input="legCusIdnHandler('O',$event)"
                            placeholder="請輸入"
                            :rules="legCusIdnRulesO"
                            :vname="idnLabel"
                            vid="legCusIdn_O"
                            mode="lazy"
                            v-mask="'XXXXXXXXXX'"
                            maxlength="10"
                            @blur="compareIdn('O',$event)"
                            outline></b-text-field>
              </div>
              <v-btn  outline
                    fab
                    small
                    v-ripple=true
                    @click="showIdnDialog('O')">
                <v-icon>search</v-icon>
              </v-btn>
              </div>
            </v-flex>
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>姓名</template>
              </sub-header>
              <v-flex xs12>
                <b-text-field v-model="cusInfo.typeO.legcusName"
                            v-checker
                            :disabled="isReadOnly || nameReadOnlyO"
                            placeholder="請輸入"
                            :rules="cusNameRulesO"
                            vname="姓名"
                            vid="legCusName_O"
                            mode="lazy"
                            maxlength="20"
                            @blur="cusInfo.typeO.legcusName =  checkEsapiRule(cusInfo.typeO.legcusName,'rule1')"
                            outline></b-text-field>
              </v-flex>
            </v-flex>
          </v-layout>

          <v-layout row
                    wrap
                    class="form">
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>性別</template>
              </sub-header>

              <b-base-yn v-model="cusInfo.typeO.legSex"
                          v-checker
                         :disabled="isReadOnly || sexReadOnlyO"
                         :items="sexList"
                         :rules="(isReadOnly || sexReadOnlyO) ? '' : 'required|gender:legNationality,legCusIdn'"
                         vname="性別"
                         vid="legSex_O"></b-base-yn>
            </v-flex>
            <v-flex sm6>
              <validation-observer v-slot="{errors}">
                <sub-header class="required"><template v-slot:title>出生日期(民國年)</template>
                </sub-header>
                <v-layout row
                          wrap
                          class="form">
                  <v-flex xs4>
                    <b-auto-or-select v-model="cusInfo.typeO.legbirthYy"
                                    v-checker
                                    :disabled="isReadOnly || birthReadOnlyO"
                                    :items="yyyItems"
                                    @change="cusInfo.typeO.legbirthDd = ''"
                                    :search-input.sync="legBirthYYSync"
                                    v-mask="'###'"
                                    maxlength="3"
                                    label="民國年"
                                    :rules="(isReadOnly || birthReadOnlyO) ? '' : 'required'"
                                    vname="出生日期"
                                    vid="legBirthYY_O"
                                    :error-messages-hidden="true"
                                    mode="lazy"
                                    ></b-auto-or-select>
                  </v-flex>
                  <v-flex xs4>
                    <b-auto-or-select v-model="cusInfo.typeO.legbirthMm"
                                    v-checker
                                    :disabled="isReadOnly || birthReadOnlyO"
                                    :items="mmItems(cusInfo.typeO.legbirthYy)"
                                    @change="cusInfo.typeO.legbirthDd = ''"
                                    :search-input.sync="legBirthMMSync"
                                    v-mask="'##'"
                                    maxlength="2"
                                    label="月"
                                    :rules="(isReadOnly || birthReadOnlyO) ? '' : 'required'"
                                    vname="出生日期"
                                    vid="legBirthMM_O"
                                    :error-messages-hidden="true"
                                    mode="lazy"
                                    ></b-auto-or-select>
                  </v-flex>
                  <v-flex xs4>
                    <b-auto-or-select v-model="cusInfo.typeO.legbirthDd"
                                    v-checker
                                    :disabled="isReadOnly || birthReadOnlyO"
                                    :items="ddItems(cusInfo.typeO.legbirthYy,cusInfo.typeO.legbirthMm)"
                                    :search-input.sync="legBirthDDSync"
                                    v-mask="'##'"
                                    maxlength="2"
                                    label="日"
                                    :rules="(isReadOnly || birthReadOnlyO) ? '' : 'required'"
                                    vname="出生日期"
                                    vid="legBirthDD_O"
                                    :error-messages-hidden="true"
                                    mode="lazy"
                                    ></b-auto-or-select>
                  </v-flex>
                </v-layout>
                <error-messages :value="errors"></error-messages>
              </validation-observer>
            </v-flex>
          </v-layout>

          <v-layout row
                    wrap
                    class="form">
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>國籍</template>
              </sub-header>
              <b-auto-or-select v-model="cusInfo.typeO.legNationality"
                              v-checker
                              :disabled="isReadOnly || nationalReadOnlyO || (polInsureType === 'R' && remoteNativeYn === 'Y')"
                              :items="countryList"
                              s-tag="autocomplete"
                              item-text="countryName"
                              item-value="countryCode"
                              :search-input.sync="legTypeONationalitySync"
                              :filter="legNationalityFilter"
                              label="請選擇"
                              :rules="(isReadOnly || nationalReadOnlyO) ? '' : 'required'"
                              vname="國籍"
                              vid="legNationality_O"
                              mode="lazy"
                              ></b-auto-or-select>
            </v-flex>
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>與要保險人關係</template>
              </sub-header>
              <v-layout row
                        wrap
                        class="form">
                <v-flex xs4>
                  <b-auto-or-select v-model="cusInfo.typeO.legRelOwnerCode"
                                  v-checker
                                  :disabled="isPreview"
                                  :items="relationLegalList"
                                  item-text="codeName"
                                  item-value="codeValue"
                                  :search-input.sync="legRelOwnerCodeSync"
                                  label="請選擇"
                                  :rules="(isPreview) ? '' : 'required'"
                                  vname="與要保險人關係"
                                  vid="legRelOwnerCode_O"
                                  mode="lazy"
                                  ></b-auto-or-select>
                </v-flex>
                <v-flex xs8>
                  <b-text-field v-if="cusInfo.typeO.legRelOwnerCode === '3'"
                                :disabled="isPreview"
                                v-model="cusInfo.typeO.legRelOwnerOther"
                                v-checker
                                placeholder="請輸入"
                                :rules="(isPreview) ? '' : 'required'"
                                vname="與要保險人關係"
                                vid="legRelOwnerOther_O"
                                mode="lazy"
                                maxlength="5"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
      </v-container>
    </base-box>
    <base-box v-if="cusInfoAllProps.typeO.legalYn === 'Y'"
              title="聯絡電話 <font color='red'>* （公司電話、住家電話和行動電話需擇一填入；遠距投保時行動電話為必填）</font>">
      <v-container grid-list-md>
          <validation-observer v-slot="{errors}">
          <error-messages
                            :value="phoneErrorsHandler(errors)"></error-messages>
          <v-layout row
                    wrap
                    class="form">
            <validation-provider vid="phoneCheckO"
                                   name="公司電話、住家電話和行動電話需擇一填入，請確認!"
                                   rules="required_prefix0"
                                   :immediate="phoneStr('O').length > 0">
                <input :value="phoneStr('O')"
                       style="height:0;width:0"
                       id="phoneCheckO" />
            </validation-provider>
            <v-flex sm6>
              <sub-header><template v-slot:title>公司電話-分機</template>
              </sub-header>
              <v-layout align-center>
                <b-text-field v-model="cusInfo.typeO.phoneC1"
                              v-checker
                              maxlength="4"
                              class="flex-phone mr-1"
                              placeholder="區碼"
                              :readonly="isReadOnly"
                              :rules="(isReadOnly) ? '' : 'min:2|required_if:phoneC2_O'"
                              vname="區碼"
                              vid="phoneC1_O"
                              hide-details
                              mode="lazy"
                              :error-messages-hidden="true"
                              @blur="cusInfo.typeO.phoneC1 = number(cusInfo.typeO.phoneC1)"
                              outline></b-text-field>-
                <b-text-field v-model="cusInfo.typeO.phoneC2"
                              v-checker
                              maxlength="8"
                              placeholder="公司電話"
                              :readonly="isReadOnly"
                              class="ml-1 mr-1"
                              hide-details
                              :rules="phoneCRules('O')"
                              vname="公司電話"
                              vid="phoneC2_O"
                              mode="lazy"
                              :error-messages-hidden="true"
                              @blur="cusInfo.typeO.phoneC2 = number(cusInfo.typeO.phoneC2)"
                              outline></b-text-field>#
                <v-text-field v-model="cusInfo.typeO.phoneC3"
                              v-checker
                              maxlength="5"
                              class="flex-extension ml-1"
                              placeholder="分機"
                              hide-details
                              :readonly="isReadOnly"
                              @blur="cusInfo.typeO.phoneC3 = number(cusInfo.typeO.phoneC3)"
                              outline></v-text-field>
              </v-layout>
              <error-messages :value="phoneErrorsHandler(errors,'phoneC')"
                                style="margin-top:0px!important;height:38px!important">
                </error-messages>
            </v-flex>
            <v-flex sm6>
              <sub-header><template v-slot:title>住家電話</template>
              </sub-header>
              <v-layout align-center>
                <b-text-field v-model="cusInfo.typeO.phoneH1"
                              v-checker
                              maxlength="4"
                              class="flex-phone mr-1"
                              placeholder="區碼"
                              hide-details
                              :readonly="isReadOnly"
                              :rules="(isReadOnly) ? '' : 'min:2|required_if:phoneH2_O'"
                              vname="區碼"
                              vid="phoneH1_O"
                              mode="lazy"
                              :error-messages-hidden="true"
                              @blur="cusInfo.typeO.phoneH1 = number(cusInfo.typeO.phoneH1)"
                              outline></b-text-field>-
                <b-text-field v-model="cusInfo.typeO.phoneH2"
                              v-checker
                              maxlength="8"
                              placeholder="住家電話"
                              :readonly="isReadOnly"
                              class="ml-1 mr-1"
                              hide-details
                              :rules="phoneHRules('O')"
                              vname="住家電話"
                              vid="phoneH2_O"
                              mode="lazy"
                              :error-messages-hidden="true"
                              @blur="cusInfo.typeO.phoneH2 = number(cusInfo.typeO.phoneH2)"
                              outline></b-text-field>#
                <v-text-field v-model="cusInfo.typeO.phoneH3"
                              v-checker
                              maxlength="5"
                              :readonly="isReadOnly"
                              class="flex-extension ml-1"
                              placeholder="分機"
                              hide-details
                              @blur="cusInfo.typeO.phoneH3 = number(cusInfo.typeO.phoneH3)"
                              outline></v-text-field>
              </v-layout>
              <error-messages :value="phoneErrorsHandler(errors,'phoneH')"
                                style="margin-top:0px!important;height:38px!important">
                </error-messages>
            </v-flex>
          </v-layout>
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm6>
              <sub-header><template v-slot:title>行動電話</template>
              </sub-header>
              <b-text-field v-model="cusInfo.typeO.legMobile"
                            v-checker
                            maxlength="10"
                            placeholder="請輸入"
                            :readonly="isReadOnly"
                            :rules="legMobileTypeORules"
                            vname="行動電話"
                            vid="mobile_O"
                            mode="lazy"
                            :error-messages-hidden="true"
                            @blur="cusInfo.typeO.legMobile = number(cusInfo.typeO.legMobile)"
                            outline></b-text-field>
              <error-messages :value="phoneErrorsHandler(errors,'mobile')">
              </error-messages>
            </v-flex>
          </v-layout>
        </validation-observer>
        </v-container>
    </base-box>

    <base-box v-if="cusInfoAllProps.typeI.legalYn === 'Y'"
              title="被保險人法定代理人資料建置"
              style="margin-bottom:50px">
        <v-container grid-list-md>
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm12>
              <font color='red'>*原住民長姓名(指特殊字)、姓名/地址有難字及受監護宣告客戶皆需改採紙本進件。</font>
            </v-flex>
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>{{ idnLabel }}</template>
              </sub-header>
              <div class="d-flex">
              <div style="width: 100%;padding-top:5px">
              <b-text-field v-model="cusInfo.typeI.legcusIdn"
                            v-checker
                            :disabled="isPreview || relOwnerShow || idnReadOnlyI"
                            @input="legCusIdnHandler('I',$event)"
                            placeholder="請輸入"
                            :rules="legCusIdnRulesI"
                            :vname="idnLabel"
                            vid="legCusIdn_I"
                            mode="lazy"
                            v-mask="'XXXXXXXXXX'"
                            maxlength="10"
                            @blur="compareIdn('I',$event)"
                            outline></b-text-field>
              </div>
              <v-btn  outline
                    fab
                    small
                    :disabled="isPreview || relOwnerShow"
                    v-ripple=true
                    @click="showIdnDialog('I')">
                <v-icon>search</v-icon>
              </v-btn>
              </div>
            </v-flex>
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>姓名</template>
              </sub-header>
              <v-flex xs12>
                <b-text-field v-model="cusInfo.typeI.legcusName"
                            v-checker
                            :disabled="isReadOnly || relOwnerShow || nameReadOnlyI"
                            placeholder="請輸入"
                            :rules="cusNameRulesI"
                            vname="姓名"
                            vid="legCusName_I"
                            mode="lazy"
                            maxlength="20"
                            @blur="cusInfo.typeI.legcusName =  checkEsapiRule(cusInfo.typeI.legcusName,'rule1')"
                            outline></b-text-field>
              </v-flex>
            </v-flex>
          </v-layout>

          <v-layout row
                    wrap
                    class="form">
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>性別</template>
              </sub-header>

              <b-base-yn v-model="cusInfo.typeI.legSex"
                          v-checker
                         :disabled="isReadOnly || relOwnerShow || sexReadOnlyI"
                         :items="sexList"
                         :rules="(isReadOnly || relOwnerShow || sexReadOnlyI) ? '' : 'required|gender:legNationality,legCusIdn'"
                         vname="性別"
                         vid="legSex_I"></b-base-yn>
            </v-flex>
            <v-flex sm6>
              <validation-observer v-slot="{errors}">
                <sub-header class="required"><template v-slot:title>出生日期(民國年)</template>
                </sub-header>
                <v-layout row
                          wrap
                          class="form">
                  <v-flex xs4>
                    <b-auto-or-select v-model="cusInfo.typeI.legbirthYy"
                                    v-checker
                                    :disabled="isReadOnly || relOwnerShow || birthReadOnlyI"
                                    :items="yyyItems"
                                    @change="cusInfo.typeI.legbirthDd = ''"
                                    :search-input.sync="legBirthYYSync"
                                    v-mask="'###'"
                                    maxlength="3"
                                    label="民國年"
                                    :rules="(isReadOnly || relOwnerShow || birthReadOnlyI) ? '' : 'required'"
                                    vname="出生日期"
                                    vid="legBirthYY_I"
                                    :error-messages-hidden="true"
                                    mode="lazy"
                                    ></b-auto-or-select>
                  </v-flex>
                  <v-flex xs4>
                    <b-auto-or-select v-model="cusInfo.typeI.legbirthMm"
                                    v-checker
                                    :disabled="isReadOnly || relOwnerShow || birthReadOnlyI"
                                    :items="mmItems(cusInfo.typeI.legbirthYy)"
                                    @change="cusInfo.typeI.legbirthDd = ''"
                                    :search-input.sync="legBirthMMSync"
                                    v-mask="'##'"
                                    maxlength="2"
                                    label="月"
                                    :rules="(isReadOnly || relOwnerShow || birthReadOnlyI) ? '' : 'required'"
                                    vname="出生日期"
                                    vid="legBirthMM_I"
                                    :error-messages-hidden="true"
                                    mode="lazy"
                                    ></b-auto-or-select>
                  </v-flex>
                  <v-flex xs4>
                    <b-auto-or-select v-model="cusInfo.typeI.legbirthDd"
                                    v-checker
                                    :disabled="isReadOnly || relOwnerShow || birthReadOnlyI"
                                    :items="ddItems(cusInfo.typeI.legbirthYy,cusInfo.typeI.legbirthMm)"
                                    :search-input.sync="legBirthDDSync"
                                    v-mask="'##'"
                                    maxlength="2"
                                    label="日"
                                    :rules="(isReadOnly || relOwnerShow || birthReadOnlyI) ? '' : 'required'"
                                    vname="出生日期"
                                    vid="legBirthDD_I"
                                    :error-messages-hidden="true"
                                    mode="lazy"
                                    ></b-auto-or-select>
                  </v-flex>
                </v-layout>
                <error-messages :value="errors"></error-messages>
              </validation-observer>
            </v-flex>
          </v-layout>

          <v-layout row
                    wrap
                    class="form">
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>國籍</template>
              </sub-header>
              <b-auto-or-select v-model="cusInfo.typeI.legNationality"
                              v-checker
                              :disabled="isReadOnly || relOwnerShow || nationalReadOnlyI || (polInsureType === 'R' && remoteNativeYn === 'Y')"
                              :items="countryList"
                              s-tag="autocomplete"
                              item-text="countryName"
                              item-value="countryCode"
                              :search-input.sync="legTypeINationalitySync"
                              :filter="legNationalityFilter"
                              label="請選擇"
                              :rules="(isReadOnly || relOwnerShow || nationalReadOnlyI) ? '' : 'required'"
                              vname="國籍"
                              vid="legNationality_I"
                              mode="lazy"
                              ></b-auto-or-select>
            </v-flex>
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>與被保險人關係</template>
              </sub-header>
              <v-layout row
                        wrap
                        class="form">
                <v-flex xs4>
                  <b-auto-or-select v-model="cusInfo.typeI.legRelOwnerCode"
                                  v-checker
                                  :disabled="isPreview || relOwnerShow"
                                  :items="relationLegalList"
                                  item-text="codeName"
                                  item-value="codeValue"
                                  :search-input.sync="legRelOwnerCodeSync"
                                  label="請選擇"
                                  :rules="(isPreview || relOwnerShow) ? '' : 'required'"
                                  vname="與被保險人關係"
                                  vid="legRelOwnerCode_I"
                                  mode="lazy"
                                  ></b-auto-or-select>
                </v-flex>
                <v-flex xs8>
                  <b-text-field v-if="cusInfo.typeI.legRelOwnerCode === '3'"
                                :disabled="isPreview || relOwnerShow"
                                v-model="cusInfo.typeI.legRelOwnerOther"
                                v-checker
                                placeholder="請輸入"
                                :rules="(isPreview || relOwnerShow) ? '' : 'required'"
                                vname="與被保險人關係"
                                vid="legRelOwnerOther_I"
                                mode="lazy"
                                maxlength="5"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          </v-container>
    </base-box>
    <base-box v-if="cusInfoAllProps.typeI.legalYn === 'Y'"
              title="聯絡電話 <font color='red'>* （公司電話、住家電話和行動電話需擇一填入；遠距投保時行動電話為必填）</font>">
      <v-container grid-list-md>
          <validation-observer v-slot="{errors}">
          <error-messages :value="phoneErrorsHandler(errors)"></error-messages>
          <v-layout row
                    wrap
                    class="form">
             <validation-provider vid="phoneCheckI"
                                   name="公司電話、住家電話和行動電話需擇一填入，請確認!"
                                   :rules="(isPreview || relOwnerShow) ? '' : 'required_prefix0'"
                                   :immediate="phoneStr('I').length > 0">
                <input :value="phoneStr('I')"
                       style="height:0;width:0"
                       id="phoneCheckI" />
            </validation-provider>
            <v-flex sm6>
              <sub-header><template v-slot:title>公司電話-分機</template>
              </sub-header>
              <v-layout align-center>
                <b-text-field v-model="cusInfo.typeI.phoneC1"
                              v-checker
                              maxlength="4"
                              class="flex-phone mr-1"
                              placeholder="區碼"
                              :readonly="isReadOnly || relOwnerShow"
                              :rules="(isPreview || relOwnerShow) ? '' : 'min:2|required_if:phoneC2_I'"
                              vname="區碼"
                              vid="phoneC1_I"
                              hide-details
                              mode="lazy"
                              :error-messages-hidden="true"
                              @blur="cusInfo.typeI.phoneC1 = number(cusInfo.typeI.phoneC1)"
                              outline></b-text-field>-
                <b-text-field v-model="cusInfo.typeI.phoneC2"
                              v-checker
                              maxlength="8"
                              placeholder="公司電話"
                              :readonly="isReadOnly || relOwnerShow"
                              class="ml-1 mr-1"
                              hide-details
                              :rules="phoneCRules('I')"
                              vname="公司電話"
                              vid="phoneC2_I"
                              mode="lazy"
                              :error-messages-hidden="true"
                              @blur="cusInfo.typeI.phoneC2 = number(cusInfo.typeI.phoneC2)"
                              outline></b-text-field>#
                <v-text-field v-model="cusInfo.typeI.phoneC3"
                              v-checker
                              maxlength="5"
                              class="flex-extension ml-1"
                              placeholder="分機"
                              hide-details
                              :readonly="isReadOnly || relOwnerShow"
                              @blur="cusInfo.typeI.phoneC3 = number(cusInfo.typeI.phoneC3)"
                              outline></v-text-field>
              </v-layout>
              <error-messages :value="phoneErrorsHandler(errors,'phoneC')"
                                style="margin-top:0px!important;height:38px!important">
                </error-messages>
            </v-flex>
            <v-flex sm6>
              <sub-header><template v-slot:title>住家電話</template>
              </sub-header>
              <v-layout align-center>
                <b-text-field v-model="cusInfo.typeI.phoneH1"
                              v-checker
                              maxlength="4"
                              class="flex-phone mr-1"
                              placeholder="區碼"
                              :readonly="isReadOnly || relOwnerShow"
                              :rules="(isReadOnly || relOwnerShow) ? '' : 'min:2|required_if:phoneH2_I'"
                              vname="區碼"
                              hide-details
                              vid="phoneH1_I"
                              mode="lazy"
                              :error-messages-hidden="true"
                              @blur="cusInfo.typeI.phoneH1 = number(cusInfo.typeI.phoneH1)"
                              outline></b-text-field>-
                <b-text-field v-model="cusInfo.typeI.phoneH2"
                              v-checker
                              maxlength="8"
                              placeholder="住家電話"
                              :readonly="isReadOnly || relOwnerShow"
                              class="ml-1 mr-1"
                              hide-details
                              :rules="phoneHRules('I')"
                              vname="住家電話"
                              vid="phoneH2_I"
                              mode="lazy"
                              :error-messages-hidden="true"
                              @blur="cusInfo.typeI.phoneH2 = number(cusInfo.typeI.phoneH2)"
                              outline></b-text-field>#
                <v-text-field v-model="cusInfo.typeI.phoneH3"
                              v-checker
                              maxlength="5"
                              :readonly="isReadOnly || relOwnerShow"
                              class="flex-extension ml-1"
                              placeholder="分機"
                              hide-details
                              @blur="cusInfo.typeI.phoneH3 = number(cusInfo.typeI.phoneH3)"
                              outline></v-text-field>
              </v-layout>
              <error-messages :value="phoneErrorsHandler(errors,'phoneH')"
                                style="margin-top:0px!important;height:38px!important">
              </error-messages>
            </v-flex>
          </v-layout>
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm6>
              <sub-header><template v-slot:title>行動電話</template>
              </sub-header>
              <b-text-field v-model="cusInfo.typeI.legMobile"
                            v-checker
                            maxlength="10"
                            placeholder="請輸入"
                            :readonly="isReadOnly || relOwnerShow"
                            :rules="legMobileTypeIRules"
                            vname="行動電話"
                            vid="mobile_I"
                            mode="lazy"
                            :error-messages-hidden="true"
                            @blur="cusInfo.typeI.legMobile = number(cusInfo.typeI.legMobile)"
                            outline></b-text-field>
              <error-messages :value="phoneErrorsHandler(errors,'mobile')">
              </error-messages>
            </v-flex>
          </v-layout>
        </validation-observer>
        </v-container>
    </base-box>
    </validation-observer>
    <base-btn>
      <btn-lg-default class="float-left"
                      :disabled="isPreview"
                      @click="restHandler">全部清除</btn-lg-default>
      <btn-lg-default @click="preStepHandler">上一步</btn-lg-default>
      <btn-lg-primary @click="nextStepHandler">下一步</btn-lg-primary>
    </base-btn>
    <btn-lg-default style="position: fixed;top: 300px;right: 30px;min-width: 126px;max-width: 126px;" @click="preStepHandler" >上一步</btn-lg-default>
    <btn-lg-primary style="position: fixed;top: 360px;right: 30px;min-width: 126px;max-width: 126px;" @click="nextStepHandler" >下一步</btn-lg-primary>
    <base-dialog-adm v-if="idnDialogShow"
                    :show="idnDialogShow"
                    :title="`請輸入${idnLabel}`"
                    width="500"
                    @close="closeIdnDialog"
                    @save="saveIdnDialog">
      <idn-card-dialog ref="idnCardDialogRef"
                       :tab-step="tabStep"
                       :check-idn="checkIdn"
                       :trans-code="transCode"
                       :comp-code="compCode"
                       :national-code="nationalCode"
                       :input-error="idnError"
                       :idn-label="idnLabel"
                       :chk-remote-native-yn="chkRemoteNativeYn"
                       :chk-agent-idno="chkAgentIdno"
                       @getCusData="getCusData"></idn-card-dialog>
    </base-dialog-adm>
  </div>
</template>
<script>
import IdnCardDialog from '@/components/Ins/Policy/IdnCardDialog'
import ProposalStepsBase from './ProposalStepsBase'
import store from '@/store'
import { pick, reduce, upperFirst, map, filter, includes } from 'lodash'
import { dateSelect, halfFull, policyChangedChecker, esapi } from '@/mixin'
import {
  isNationalIdentificationNumberValid,
  isResidentCertificateNumberValid
} from 'taiwan-id-validator'
import { withDebounce } from '@/utils'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('ins')
const isDev = process.env.NODE_ENV === 'development'
export default {
  components: { IdnCardDialog },
  extends: ProposalStepsBase,
  mixins: [dateSelect, halfFull, policyChangedChecker, esapi],
  data () {
    return {
      cusInfoAllProps: {
        typeI: { cusCode: '' },
        typeO: { cusCode: '' }
      },
      typeCode: 'O',
      nationalCode: '',
      checkIdn: null,
      idnDialogShow: false,
      legalAgentProps: [],
      idnLabel: '身分證/居留證號碼',
      cusInfo: {
        typeO: {
          legcusIdn: null, // 身分證/居留證號碼
          legcusName: null, // 姓名
          legSex: null, // 性別
          legbirthday: '', // 出生日期
          legbirthYy: '', // 出生日期-年
          legbirthMm: '', // 出生日期-月
          legbirthDd: '', // 出生日期-日
          legNationality: '', // 國家代碼
          legRelOwnerCode: null, // 與要/被保人關係代碼
          legRelOwnerOther: null, // 與要/被保人關係代碼
          legPhoneC: null, // 連絡電話公司
          legPhoneH: null, // 連絡電話家
          legMobile: '',
          legGetDataYn: null,
          legAmlResult: null,
          phoneC1: '',
          phoneC2: '',
          phoneC3: '',
          phoneH1: '',
          phoneH2: '',
          phoneH3: ''
        },
        typeI: {
          legcusIdn: null, // 身分證/居留證號碼
          legcusName: null, // 姓名
          legSex: null, // 性別
          legbirthday: '', // 出生日期
          legbirthYy: '', // 出生日期-年
          legbirthMm: '', // 出生日期-月
          legbirthDd: '', // 出生日期-日
          legNationality: '', // 國家代碼
          legRelOwnerCode: null, // 與要/被保人關係代碼
          legRelOwnerOther: null, // 與要/被保人關係代碼
          legPhoneC: null, // 聯絡電話公司
          legPhoneH: null, // 聯絡電話家
          legMobile: '',
          legGetDataYn: null,
          legAmlResult: null,
          phoneC1: '',
          phoneC2: '',
          phoneC3: '',
          phoneH1: '',
          phoneH2: '',
          phoneH3: ''
        }
      },
      legBirthYYSync: null,
      legBirthMMSync: null,
      legBirthDDSync: null,
      legTypeONationalitySync: null,
      legTypeINationalitySync: null,
      legRelOwnerCodeSync: null,
      relOwnerShow: false,
      idnReadOnlyO: false,
      nameReadOnlyO: false,
      sexReadOnlyO: false,
      birthReadOnlyO: false,
      nationalReadOnlyO: false,
      idnReadOnlyI: false,
      nameReadOnlyI: false,
      sexReadOnlyI: false,
      birthReadOnlyI: false,
      nationalReadOnlyI: false,
      idnError: '',
      chkRemoteNativeYn: false,
      chkAgentIdno: ''
    }
  },

  computed: {
    cusNameRulesO () {
      let rules = 'required'
      const { isReadOnly, nameReadOnlyO } = this
      const { legNationality, legcusName } = this.cusInfo.typeO
      if (isReadOnly || nameReadOnlyO) {
        return ''
      } else {
        if (legcusName) {
          let showMsg = ''
          if (legNationality && legNationality === 'TW') {
            if (this.hasBlankChar(legcusName)) {
              showMsg += '姓名不能有空白!'
            }
          }
          if (this.hasSpecialChar(legcusName)) {
            showMsg += '原住民長姓名(指特殊字)、姓名/地址有難字及受監護宣告客戶皆需改採紙本進件!'
          }
          if (showMsg) {
            rules += '|showMsg:' + showMsg
          }
        }
      }
      return rules
    },
    cusNameRulesI () {
      let rules = 'required'
      const { isReadOnly, relOwnerShow, nameReadOnlyI } = this
      const { legNationality, legcusName } = this.cusInfo.typeI
      if (isReadOnly || relOwnerShow || nameReadOnlyI) {
        return ''
      } else {
        if (legcusName && legNationality && legNationality === 'TW') {
          let showMsg = ''
          if (this.hasBlankChar(legcusName)) {
            showMsg += '姓名不能有空白!'
          }
          if (this.hasSpecialChar(legcusName)) {
            showMsg += '原住民長姓名(指特殊字)、姓名/地址有難字及受監護宣告客戶皆需改採紙本進件!'
          }
          if (showMsg) {
            rules += '|showMsg:' + showMsg
          }
        }
      }
      return rules
    },
    relationLegalList () {
      return this.$store.getters['common/allAdmCodeDetail']( 'LEG_REL_OWNER_CODE' )
    },
    remoteNativeYn () {
      // (ADM_PARMD-S01) 遠距是否限本國人
      let { parameterValue: yn } = this.insParameters['REMOTE_NATIVE_YN']
      return yn
    },
    highAgeLimit () {
      // (ADM_PARMD-S01) 高齡年齡限制
      let { parameterValue: limit } = this.insParameters['HIGH_AGE_LIMIT']
      limit = parseInt(limit)
      return limit
    },
    sexList () {
      let list = this.$store.getters['common/admCodeDetail']({ codeType: 'SEX' })
      list = map(list, v => {
        return { text: v.codeName, value: v.codeValue }
      })
      return list
    },
    isReadOnly () {
      return this.isPreview
    },
    legCusIdnRulesO () {
      const {isPreview, idnReadOnlyO } = this
      if (isPreview || idnReadOnlyO) {
        return ''
      }
      let rules = 'required|min:10'
      const { legNationality, legcusIdn } = this.cusInfo.typeO
      const { cusIdn } = this.cusInfoAllProps.typeO

      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        if (!isNationalIdentificationNumberValid(legcusIdn) && legcusIdn && legcusIdn.length == 10) {
          // 身分證驗證
          rules = `${rules}|showMsg:身分證號碼有誤，遠距投保只限本國自然人，請確認!`
          return rules
        }
      }

      rules = `${rules}|isSameLegal:${cusIdn}`
      if (!legNationality) {
        if (isNationalIdentificationNumberValid(legcusIdn)) { // 身分證驗證
          rules = `${rules}|twId`
        } else if (isResidentCertificateNumberValid(legcusIdn)) { // 居留證驗證
          rules = `${rules}|residentId`
        } else {
          rules = `${rules}|twId`
        }
      }
      if (legNationality && legNationality === 'TW') {
        rules = `${rules}|twId`
      } else if (legNationality && legNationality !== 'TW') {
        rules = `${rules}|residentId`
      }

      if (this.polInsureType === 'R') {
        let admUsers = this.$store.getters["common/admUserInfo"]
        if (legcusIdn === admUsers.idno) {
          rules += '|showMsg:遠距投保不得為自保件！'
        }
      }

      return rules
    },
    legCusIdnRulesI () {
      const {isPreview, idnReadOnlyI } = this
      if (isPreview || idnReadOnlyI) {
        return ''
      }
      let rules = 'required|min:10'
      const { legNationality, legcusIdn } = this.cusInfo.typeI
      const { cusIdn } = this.cusInfoAllProps.typeI

      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        if (!isNationalIdentificationNumberValid(legcusIdn) && legcusIdn && legcusIdn.length == 10) {
          // 身分證驗證
          rules = `${rules}|showMsg:身分證號碼有誤，遠距投保只限本國自然人，請確認!`
          return rules
        }
      }

      rules = `${rules}|isSameLegal:${cusIdn}`
      if (!legNationality) {
        if (isNationalIdentificationNumberValid(legcusIdn)) { // 身分證驗證
          rules = `${rules}|twId`
        } else if (isResidentCertificateNumberValid(legcusIdn)) { // 居留證驗證
          rules = `${rules}|residentId`
        } else {
          rules = `${rules}|twId`
        }
      }
      if (legNationality && legNationality === 'TW') {
        rules = `${rules}|twId`
      } else if (legNationality && legNationality !== 'TW') {
        rules = `${rules}|residentId`
      }

      if (this.polInsureType === 'R') {
        let admUsers = this.$store.getters["common/admUserInfo"]
        if (legcusIdn === admUsers.idno) {
          rules += '|showMsg:遠距投保不得為自保件！'
        }
      }

      return rules
    },
    legMobileTypeORules () {
      let rules = (this.isReadOnly) ? '' : 'min:10|mobilePhone2'

      if (!this.isReadOnly && this.polInsureType === 'R' && !this.cusInfo.typeO.legMobile) {
        if (rules) {
          rules += '|'
        }
        rules += 'showMsg:遠距投保時行動電話為必填，請確認!'
      }

      return rules
    },
    legMobileTypeIRules () {
      let rules = (this.isReadOnly || this.relOwnerShow) ? '' : 'min:10|mobilePhone2'

      if (!(this.isReadOnly || this.relOwnerShow)
           && this.polInsureType === 'R' && !this.cusInfo.typeI.legMobile) {
        if (rules) {
          rules += '|'
        }
        rules += 'showMsg:遠距投保時行動電話為必填，請確認!'
      }

      return rules
    }
  },
  watch: {
    legalAgentProps: {
      handler (v) {
        if (v && v.length > 0) {
          const [legalTypeO] = filter(v, { cusType: 'O' }) || {}
          const [legalTypeI] = filter(v, { cusType: 'I' }) || {}
          if (legalTypeO && !!legalTypeO.legStatus) {// legStatus不為空
            this.cusInfo.typeO = { ...this.$options.data().cusInfo.typeO, ...legalTypeO }

            if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
              this.cusInfo.typeO.legNationality = 'TW'
            }
            if (this.cusInfo.typeO.legGetDataYn === 'Y') {
              if (!this.cusInfo.typeO.legcusIdn) { this.idnReadOnlyO = true }
              if (!this.cusInfo.typeO.legcusName) { this.nameReadOnlyO = true }
              if (!this.cusInfo.typeO.legSex) { this.sexReadOnlyO = true }
              if (!this.cusInfo.typeO.legbirthday) { this.birthReadOnlyO = true }
              this.applyLegalNationalityResult('O', this.cusInfo.typeO.legNationality, this.cusInfo.typeO.legcusIdn)
            }
            if (this.cusInfo.typeO.legPhoneC) {
              const [ phoneC1_O = null, phoneC2_O = null, phoneC3_O = null ] = this.phoneSplit(this.cusInfo.typeO.legPhoneC)
              if (phoneC2_O === null && phoneC3_O === null) {
                this.cusInfo.typeO.phoneC2 = phoneC1_O
              } else {
                this.cusInfo.typeO.phoneC1 = phoneC1_O
                this.cusInfo.typeO.phoneC2 = phoneC2_O
                this.cusInfo.typeO.phoneC3 = phoneC3_O
              }
            }
            if (this.cusInfo.typeO.legPhoneH) {
              const [ phoneH1_O = null, phoneH2_O = null, phoneH3_O = null ] = this.phoneSplit(this.cusInfo.typeO.legPhoneH)
              if (phoneH2_O === null && phoneH3_O === null) {
                this.cusInfo.typeO.phoneH2 = phoneH1_O
              } else {
                this.cusInfo.typeO.phoneH1 = phoneH1_O
                this.cusInfo.typeO.phoneH2 = phoneH2_O
                this.cusInfo.typeO.phoneH3 = phoneH3_O
              }
            }
          }
          if (legalTypeI && !!legalTypeI.legStatus) {
            this.cusInfo.typeI = { ...this.$options.data().cusInfo.typeI, ...legalTypeI }
            if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
              this.cusInfo.typeI.legNationality = 'TW'
            }
            if (this.cusInfo.typeI.legGetDataYn === 'Y') {
              if (!this.cusInfo.typeI.legcusIdn) { this.idnReadOnlyI = true }
              if (!this.cusInfo.typeI.legcusName) { this.nameReadOnlyI = true }
              if (!this.cusInfo.typeI.legSex) { this.sexReadOnlyI = true }
              if (!this.cusInfo.typeI.legbirthday) { this.birthReadOnlyI = true }
              this.applyLegalNationalityResult('I', this.cusInfo.typeI.legNationality, this.cusInfo.typeI.legcusIdn)
            }
            if (this.cusInfo.typeI.legPhoneC) {
              const [ phoneC1_I = null, phoneC2_I = null, phoneC3_I = null ] = this.phoneSplit(this.cusInfo.typeI.legPhoneC)
              if (phoneC2_I === null && phoneC3_I === null) {
                this.cusInfo.typeI.phoneC2 = phoneC1_I
              } else {
                this.cusInfo.typeI.phoneC1 = phoneC1_I
                this.cusInfo.typeI.phoneC2 = phoneC2_I
                this.cusInfo.typeI.phoneC3 = phoneC3_I
              }
            }
            if (this.cusInfo.typeI.legPhoneH) {
              const [ phoneH1_I = null, phoneH2_I = null, phoneH3_I = null ] = this.phoneSplit(this.cusInfo.typeI.legPhoneH)
              if (phoneH2_I === null && phoneH3_I === null) {
                this.cusInfo.typeI.phoneH2 = phoneH1_I
              } else {
                this.cusInfo.typeI.phoneH1 = phoneH1_I
                this.cusInfo.typeI.phoneH2 = phoneH2_I
                this.cusInfo.typeI.phoneH3 = phoneH3_I
              }
            }
          }
        }
      },
      immediate: true,
      deep: true
    },
    'cusInfo.typeO':{
      handler (v) {
        if (this.cusInfoAllProps.typeI && this.cusInfoAllProps.typeI.relationOwnerCode === '1') {
          this.cusInfo.typeI = v
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeRouteEnter (to, from, next) {
    const { transCode, policyLegAgent, insuredLegAgent } = to.params.propKey
    const reqAgentService = store.dispatch('ins/checkAgentService', { transCode: transCode }) // SRV_1
    const reqLegalAgent = store.dispatch('ins/fetchLegalAgent', { transCode: transCode }) // SRV_2
    Promise.all([reqAgentService, reqLegalAgent]).then(r => {
      const [r1, r2] = r
      const [typeI] = filter(r1.data, { cusType: 'I' }) || { cusCode: '' }
      const [typeO] = filter(r1.data, { cusType: 'O' }) || { cusCode: '' }
      next(vm => {
        vm.policyLegAgent = policyLegAgent
        vm.insuredLegAgent = insuredLegAgent
        vm.cusInfoAllProps.typeI = typeI
        vm.cusInfoAllProps.typeO = typeO
        vm.legalAgentProps = r2.data || []
        if (typeI.relationOwnerCode === '1') {
          vm.relOwnerShow = true
        }
        if (vm.polInsureType === 'R' && vm.remoteNativeYn === 'Y') {
          vm.idnLabel = '身分證號碼'
        }

        if (typeI.legStatus === 'W' || typeO.legStatus === 'W') {
          vm.$nextTick(() => {
                  setTimeout(() => {
                    vm.doValidate()
                  }, 0)
                })
        }
      })
    })
  },

  methods: {
    ...mapActions([
      'fetchLegalAgent',
      'postLegalAgent',
      'checkCusName'
    ]),
    reset () {
      const { cusInfo } = this.$options.data()
      this.cusInfo = cusInfo
      this.idnReadOnlyO = false
      this.nameReadOnlyO = false
      this.sexReadOnlyO = false
      this.birthReadOnlyO = false
      this.nationalReadOnlyO = false
      this.idnReadOnlyI = false
      this.nameReadOnlyI = false
      this.sexReadOnlyI = false
      this.birthReadOnlyI = false
      this.nationalReadOnlyI = false
    },
    restHandler () {
      this.reset()

      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        this.cusInfo.typeO.legNationality = 'TW'
        this.cusInfo.typeI.legNationality = 'TW'
      }

      this.$reset('observer')
      this.changedFlag = true
      this.$emit('go-top')
      this.policyLegAgent = 'N'
      this.insuredLegAgent = 'N'
      this.updateLegalStatus({ typeCode: 'ALL' })
      this.$postUserAccessLog({ progClassName: 'legalAgent_clear', methodName: '全部清除', stepCode: this.tabStep })
    },
    checkLegalIdn () {
      let msg = ''
      // 檢核身分證
      if (this.cusInfoAllProps.typeO.legalYn === 'Y') {
        if (!this.cusInfo.typeO.legcusIdn) {
          msg += '請填寫要保人法定代理人' + this.idnLabel + '!<br>'
        } else {
          if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y' && !(isNationalIdentificationNumberValid(this.cusInfo.typeO.legcusIdn))) {
            msg += '要保人法定代理人' + this.idnLabel + '錯誤!<br>'
          } else if (!(isNationalIdentificationNumberValid(this.cusInfo.typeO.legcusIdn) || isResidentCertificateNumberValid(this.cusInfo.typeO.legcusIdn))) {
            msg += '要保人法定代理人' + this.idnLabel + '錯誤!<br>'
          }
          if (this.cusInfo.typeO.legcusIdn === this.cusInfoAllProps.typeO.cusIdn) {
            msg += '要保人身分證不可與需法定代理人同一人，請確認<br>'
          }

          if (this.polInsureType === 'R') {
            let admUsers = this.$store.getters["common/admUserInfo"]
            if (this.cusInfo.typeO.legcusIdn === admUsers.idno) {
              msg += '遠距投保不得為自保件！<br>'
            }
          }
        }
      }
      if (this.cusInfoAllProps.typeI.legalYn === 'Y' && !this.relOwnerShow) {
        if (!this.cusInfo.typeI.legcusIdn) {
          msg += '請填寫被保險人法定代理人' + this.idnLabel + '!<br>'
        } else {
          if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y' && !(isNationalIdentificationNumberValid(this.cusInfo.typeI.legcusIdn))) {
            msg += '被保險人法定代理人' + this.idnLabel + '錯誤!<br>'
          } else if (!(isNationalIdentificationNumberValid(this.cusInfo.typeI.legcusIdn) || isResidentCertificateNumberValid(this.cusInfo.typeI.legcusIdn))) {
            msg += '被保險人法定代理人' + this.idnLabel + '錯誤!<br>'
          }
          if (this.cusInfo.typeI.legcusIdn === this.cusInfoAllProps.typeI.cusIdn) {
            msg += '被保險人身分證不可與需法定代理人同一人，請確認<br>'
          }

          if (this.polInsureType === 'R') {
            let admUsers = this.$store.getters["common/admUserInfo"]
            if (this.cusInfo.typeI.legcusIdn === admUsers.idno) {
              msg += '遠距投保不得為自保件！<br>'
            }
          }
        }
      }

      return msg
    },
    compareIdn (typeCode, idn) { // 比對IDN
      // let cusInfoSame = null
      // let matched = false
      // if (this.cusInfoCopyProps.cusIdn === idn) { // 和要保人同一人
      //   cusInfoSame = this.cusInfoCopyProps
      //   matched = true
      // } else if (this.cusInfoAllProps.typeI && this.cusInfoAllProps.typeI.cusIdn === idn) { // 和被保險人同一人
      //   cusInfoSame = this.cusInfoAllProps.typeI
      //   matched = true
      // } else if (this.cusInfoAllProps.typeF && this.cusInfoAllProps.typeF.length > 0) {
      //   this.cusInfoAllProps.typeF.forEach(e => {
      //     if (e.cusIdn === idn) {
      //       cusInfoSame = e
      //       matched = true
      //     }
      //   })
      // }

      //   this.cusInfo = { ...copy }
      //   if (this.keepLegRelOwnerCode != null) {
      //     this.cusInfo.legRelOwnerCode = this.keepLegRelOwnerCode
      //     this.cusInfo.legRelOwnerOther = this.keepLegRelOwnerOther
      //     this.cusInfo.legPhone = this.keeplegPhone
      //     this.keepLegRelOwnerCode = null
      //     this.keepLegRelOwnerOther = null
      //     this.keeplegPhone = null
      //   }
      // }
      // this.keepLegRelOwnerCode = null
      // this.keepLegRelOwnerOther = null
      // this.keeplegPhone = null
    },
    tempSave: withDebounce(function () {
      const tempCallback = () => {
        this.$alert('暫存成功')
      }
      let resultO = {...this.cusInfo.typeO}
      resultO.legbirthday = `${resultO.legbirthYy}/${resultO.legbirthMm}/${resultO.legbirthDd}`
      if (resultO.legRelOwnerCode !== '3') {
        resultO.legRelOwnerOther = ''
      }
      resultO.legPhoneC = this.phoneCMerge('O')
      resultO.legPhoneH = this.phoneHMerge('O')
      resultO.legGetDataYn = this.policyLegAgent
      let resultI = {...this.cusInfo.typeI}
      resultI.legbirthday = `${resultI.legbirthYy}/${resultI.legbirthMm}/${resultI.legbirthDd}`
      if (resultI.legRelOwnerCode !== '3') {
        resultI.legRelOwnerOther = ''
      }
      resultI.legPhoneC = this.phoneCMerge('I')
      resultI.legPhoneH = this.phoneHMerge('I')
      resultI.legGetDataYn = this.insuredLegAgent
      let result = {
        typeO: resultO,
        typeI: resultI
      }
      if (this.changedFlag) {
        result.changedFlag = this.changedFlag
      }
      this.$changedReset()
      // this.$emit('temp-save', { result: result, tempCallback })
      this.tempSaveHandler({ result: result, tempCallback })
    }),
    tempSaveHandler ({ result, tempCallback }) {
      this.saveHandler(result, true).then(() => {
        this.$postUserAccessLog({ progClassName: 'legalAgent_tempsave', methodName: '暫存', stepCode: this.tabStep })
        tempCallback && tempCallback()
      })
    },
    preStepHandler () {
      this.$postUserAccessLog({ progClassName: 'legalAgent_prev', methodName: '上一步', stepCode: this.tabStep })
      this.$preStepHandler()
    },
    nextStepHandler: withDebounce(function () {
      if (this.isPreview) {
        this.$postUserAccessLog({ progClassName: 'legalAgent_next', methodName: '下一步', stepCode: this.tabStep })
        this.$nextStepHandler()
        return
      }

      const checkMsg = this.checkLegalIdn()
      if (checkMsg.length > 0) {
        this.$alert(checkMsg)
        return
      }
      // 做檢核與準備資料儲存等等動作...
      // this.$doValidate('observer').then(isValid => {
        // if (isValid) {
          this.doValidate(true)

          let resultO = {...this.cusInfo.typeO}
          resultO.legbirthday = `${resultO.legbirthYy}/${resultO.legbirthMm}/${resultO.legbirthDd}`
          if (resultO.legRelOwnerCode !== '3') {
            resultO.legRelOwnerOther = ''
          }
          resultO.legPhoneC = this.phoneCMerge('O')
          resultO.legPhoneH = this.phoneHMerge('O')
          resultO.legGetDataYn = this.policyLegAgent

          let resultI = {...this.cusInfo.typeI}
          resultI.legbirthday = `${resultI.legbirthYy}/${resultI.legbirthMm}/${resultI.legbirthDd}`
          if (resultI.legRelOwnerCode !== '3') {
            resultI.legRelOwnerOther = ''
          }
          resultI.legPhoneC = this.phoneCMerge('I')
          resultI.legPhoneH = this.phoneHMerge('I')
          resultI.legGetDataYn = this.insuredLegAgent

          let result = { typeO: resultO, typeI: resultI }
          let idnCardList = []
          let codeTypeList = []
          if (this.cusInfoAllProps.typeO.legalYn === 'Y') {
            idnCardList.push(resultO.legcusIdn)
            codeTypeList.push('O')
          }
          if (this.cusInfoAllProps.typeI.legalYn === 'Y' && !this.relOwnerShow) {
            idnCardList.push(resultI.legcusIdn)
            codeTypeList.push('I')
          }
          if (this.changedFlag) {
            result.changedFlag = this.changedFlag
          }
          this.$changedReset()
          this.checkCusName({ transCode: this.transCode, compCode: this.compCode, idnCardList: idnCardList,codeTypeList: codeTypeList }).then(r => {
            if (r.data.status === 'E' && !isDev) {// 失敗
              this.$alert(r.data.message)
            } else if(r.data.status === 'M') {// 複選
              this.$alert(r.data.message).then(() => {
                if(codeTypeList.length > 1) {
                  result.typeO.amlResult = r.data.amlResult
                  result.typeI.amlResult = r.data.secAmlResult
                } else {
                  if (codeTypeList[0] === 'O') {
                    result.typeO.amlResult = r.data.amlResult
                  } else {
                    result.typeI.amlResult = r.data.amlResult
                  }
                }
                this.saveHandler(result).then(() => {
                  this.$postUserAccessLog({ progClassName: 'legalAgent_next', methodName: '下一步', stepCode: this.tabStep })
                  this.$nextStepHandler()
                })
              })
            } else { // 成功
              this.saveHandler(result).then(() => {
                this.$postUserAccessLog({ progClassName: 'legalAgent_next', methodName: '下一步', stepCode: this.tabStep })
                this.$nextStepHandler()
              })
            }
          })
        // }
      // })
    }),

    saveHandler (result, isTemp = false) {
      const { transCode } = this
    //   const opt = { cus: result, stepCode: 'INS_S4', isTemp }
    //   const cusInfoData = this.getCusInfoData(opt)
    //   if (result.changedFlag) {
    //     this.delInsRec({ type: 'A', transCode })
    //   }
    //   cusInfoData.progClassName = isTemp ? 'CusLegalAgent_tempsave' : 'CusLegalAgent_next'
    //   cusInfoData.methodName = isTemp ? '暫存' : '下一步'
    //   cusInfoData.stepCode = 'INS_S4'
      result.transCode = transCode
      const req = this.postLegalAgent(result).then(() => {
        // if (isTemp) {
        //   return this.fetchLegalAgent({ transCode }).then(r => {
        //     this.cusInfo.legalAgent = r.data
        //   })
        // }
      })
      return req
    },
    legCusIdnHandler (type, id) {
      if (id) {
        this.cusInfo[`type${type}`].legcusIdn = id.toUpperCase()
        if (id.length > 1 && (id[1] === '1' || id[1] === '8' || id[1] === 'A' || id[1] === 'C')) {
          this.cusInfo[`type${type}`].legSex = '1'
        } else if (id.length > 1 && (id[1] === '2' || id[1] === '9' || id[1] === 'B' || id[1] === 'D')) {
          this.cusInfo[`type${type}`].legSex = '2'
        } else {
          this.cusInfo[`type${type}`].legSex = null
        }
        if (isNationalIdentificationNumberValid(id)) {
          this.cusInfo[`type${type}`].legNationality = 'TW'
        } else {
          if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
            this.cusInfo[`type${type}`].legNationality = 'TW'
          } else if (this.cusInfo[`type${type}`].legNationality === 'TW') {
            this.cusInfo[`type${type}`].legNationality = null
          }
        }
      }
    },
    legNationalityFilter (item, queryText, itemText) {
      return (
        item.countryCode // 調整為countryCode
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.countryName
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      )
    },
    resolveLegalNationalityResult (apiNationality, idNumber) {
      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        return {
          nationality: 'TW',
          nationalReadOnly: true
        }
      }

      const normalizedNationality = apiNationality || ''
      if (isNationalIdentificationNumberValid(idNumber)) {
        return {
          nationality: 'TW',
          nationalReadOnly: true
        }
      }

      const hasNationalityInList = this.countryList.some(item => item.countryCode === normalizedNationality)
      if (normalizedNationality && hasNationalityInList) {
        return {
          nationality: normalizedNationality,
          nationalReadOnly: true
        }
      }

      return {
        nationality: null,
        nationalReadOnly: false
      }
    },
    applyLegalNationalityResult (typeCode, apiNationality, idNumber) {
      const { nationality, nationalReadOnly } = this.resolveLegalNationalityResult(apiNationality, idNumber)
      this.cusInfo[`type${typeCode}`].legNationality = nationality

      if (typeCode === 'O') {
        this.nationalReadOnlyO = nationalReadOnly
      } else {
        this.nationalReadOnlyI = nationalReadOnly
      }

      return { nationality, nationalReadOnly }
    },
    phoneErrorsHandler (errors, field) {
      const errorsArray = this.$errorMsgHandler(errors)
      const groupRequired = filter(errorsArray, msg =>
        /.*需擇一填入.*/.test(msg)
      )
      if (!field) {
        return groupRequired
      }

      errors = reduce(
        errors,
        (r, v, k) => {
          v = filter(v, msg => !/.*需擇一填入.*/.test(msg))
          const isFieldMatch = k.indexOf(field) > -1
          isFieldMatch && (r[k] = v)
          return r
        },
        {}
      )
      return errors
    },
    getCusData (result) {
      this.idnError = ''
      /* 這裏的判斷改在idnCardDialog內做
      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        if (!isNationalIdentificationNumberValid(result.legcusIdn)) {
          this.idnError = '身分證號碼有誤，遠距投保只限本國自然人，請確認!'
          return
        }
      }
      */

      this.idnDialogShow = false
      const { typeCode } = this
      this.cusInfo[`type${typeCode}`].legcusIdn = result.legcusIdn
      this.cusInfo[`type${typeCode}`].legcusName = result.legcusName
      this.cusInfo[`type${typeCode}`].legSex = result.legSex
      this.cusInfo[`type${typeCode}`].legbirthday = result.legbirthday
      if (result.legbirthday) {
        let [birthYY, birthMM, birthDD] = result.legbirthday.split('/')
        this.cusInfo[`type${typeCode}`].legbirthYy = (parseInt(birthYY) - 1911).toString().padStart(3, '0')
        this.cusInfo[`type${typeCode}`].legbirthMm = birthMM
        this.cusInfo[`type${typeCode}`].legbirthDd = birthDD
      }
      const { nationalReadOnly } = this.applyLegalNationalityResult(typeCode, result.legNationality || result.Country || result.Contry, result.legcusIdn || result.cusIdn)
      this.cusInfo[`type${typeCode}`].phoneC1 = ''
      this.cusInfo[`type${typeCode}`].phoneC2 = result.legPhoneC
      this.cusInfo[`type${typeCode}`].phoneC3 = ''
      this.cusInfo[`type${typeCode}`].phoneH1 = ''
      this.cusInfo[`type${typeCode}`].phoneH2 = result.legPhoneH
      this.cusInfo[`type${typeCode}`].phoneH3 = ''
      this.cusInfo[`type${typeCode}`].legMobile = result.mobile
      this.cusInfo[`type${typeCode}`].legAmlResult = result.legAmlResult
      this.$alert('請業務員確實詢問客戶，並將電話區碼、號碼、分機(若有)，採分欄個別拆分後填入。').then(() => {
        if (typeCode === 'O') {
          this.idnReadOnlyO = !this.cusInfo[`type${typeCode}`].legcusIdn ? false : true
          this.nameReadOnlyO = !this.cusInfo[`type${typeCode}`].legcusName ? false : true
          this.sexReadOnlyO = !this.cusInfo[`type${typeCode}`].legSex ? false : true
          this.birthReadOnlyO = !this.cusInfo[`type${typeCode}`].legbirthday ? false : true
          this.nationalReadOnlyO = nationalReadOnly
          this.policyLegAgent = 'Y'
        } else {
          this.idnReadOnlyI = !this.cusInfo[`type${typeCode}`].legcusIdn ? false : true
          this.nameReadOnlyI = !this.cusInfo[`type${typeCode}`].legcusName ? false : true
          this.sexReadOnlyI = !this.cusInfo[`type${typeCode}`].legSex ? false : true
          this.birthReadOnlyI = !this.cusInfo[`type${typeCode}`].legbirthday ? false : true
          this.nationalReadOnlyI = nationalReadOnly
          this.insuredLegAgent = 'Y'
        }
        this.$emit('update-legal-status', { typeCode: typeCode })
      })
      this.$postUserAccessLog({ progClassName: 'legalAgent_Idn_' + this.typeCode + '_confirm', methodName: this.typeCode === 'O' ? '確定(身分證發查-要保人法定代理人)' : '確定(身分證發查-被保險人法定代理人)', stepCode: this.tabStep })
    },
    showIdnDialog(type) {
      this.nationalCode = type === 'O' ? this.cusInfo.typeO.legNationality : this.cusInfo.typeI.legNationality
      this.typeCode = type
      this.checkIdn = type === 'O' ? this.cusInfoAllProps.typeO.cusIdn : this.cusInfoAllProps.typeI.cusIdn
      this.$postUserAccessLog({ progClassName: 'legalAgent_Idn_' + this.typeCode, methodName: this.typeCode === 'O' ? '身分證發查(要保人法定代理人)' : '身分證發查(被保險人法定代理人)', stepCode: this.tabStep })
      this.idnError = ''
      this.chkRemoteNativeYn = false
      this.chkAgentIdno = ''
      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        this.chkRemoteNativeYn = true
      }
      if (this.polInsureType === 'R') {
        let admUsers = this.$store.getters["common/admUserInfo"]
        this.chkAgentIdno = admUsers.idno
      }

      this.idnDialogShow = true
    },
    closeIdnDialog () {
      this.$postUserAccessLog({ progClassName: 'legalAgent_Idn_' + this.typeCode + '_cancel', methodName: this.typeCode === 'O' ? '取消(身分證發查-要保人法定代理人)' : '取消(身分證發查-被保險人法定代理人)', stepCode: this.tabStep })
      this.idnDialogShow = false
    },
    saveIdnDialog () {
      this.$refs['idnCardDialogRef'].saveHandler()
    },
    phoneCMerge (typeCode) {
      const { phoneC1, phoneC2, phoneC3 } = this.cusInfo[`type${typeCode}`]
      const isValid = phoneC1 && phoneC2
      let r = ''
      if (isValid) {
        r = phoneC3
          ? `${phoneC1}-${phoneC2}#${phoneC3}`
          : `${phoneC1}-${phoneC2}#`
      } else {
        r = phoneC2
      }
      return r
    },
    phoneHMerge (typeCode) {
      const { phoneH1, phoneH2, phoneH3 } = this.cusInfo[`type${typeCode}`]
      const isValid = phoneH1 && phoneH2
      let r = ''
      if (isValid) {
        r = phoneH3
          ? `${phoneH1}-${phoneH2}#${phoneH3}`
          : `${phoneH1}-${phoneH2}#`
      } else {
        r = phoneH2
      }
      return r
    },
    phoneSplit (phone) {
      if (!phone) return []
      phone = phone.replace('#', '-')
      return phone.split('-')
    },
    phoneStr (typeCode) {
      let phoneC = (this.cusInfo[`type${typeCode}`].phoneC2)?this.cusInfo[`type${typeCode}`].phoneC2:''
      let phoneH = (this.cusInfo[`type${typeCode}`].phoneH2)?this.cusInfo[`type${typeCode}`].phoneH2:''
      let mobile = (this.cusInfo[`type${typeCode}`].legMobile)?this.cusInfo[`type${typeCode}`].legMobile:''
      return phoneC + phoneH + mobile
    },
    phoneCRules(typeCode) {
      let rules = `required_if:phoneC1_${typeCode}`
      const { isReadOnly, nameReadOnlyO, relOwnerShow } = this
      const { phoneC1, phoneC2 } = this.cusInfo[`type${typeCode}`]
      if (typeCode === 'O') {
        if (isReadOnly || nameReadOnlyO) {
          return ''
        }
      } else if (typeCode === 'I') {
        if (isReadOnly || relOwnerShow) {
          return ''
        }
      }
      if (phoneC1 && phoneC2) {
        if ((phoneC1.length + phoneC2.length) < 9 || (phoneC1.length + phoneC2.length) > 10 ) {
          rules += '|showMsg:區碼+電話限制總長度9~10碼'
        }
      }
      return rules
    },
    phoneHRules (typeCode) {
      let rules = `required_if:phoneH1_${typeCode}`
      const { isReadOnly , relOwnerShow } = this
      const { phoneH1, phoneH2 } = this.cusInfo[`type${typeCode}`]
      if (typeCode === 'O') {
        if (isReadOnly ) {
          return ''
        }
      } else if (typeCode === 'I') {
        if (isReadOnly || relOwnerShow) {
          return ''
        }
      }
      if (phoneH1 && phoneH2) {
        if ((phoneH1.length + phoneH2.length) < 9 || (phoneH1.length + phoneH2.length) > 10 ) {
          rules += '|showMsg:區碼+電話限制總長度9~10碼'
        }
      }
      return rules
    },
    doValidate (setDoneFlag) {
      this.$doValidate('observer').then(isValid => {
        if (!isValid) {
          let num = this.$validateNum('observer')
          this.$emit('set-validate-num', { step: this.tabStep, num })
          this.$setTabDone(this.tabStep, false )
        } else {
          this.$emit('set-validate-num', { step: this.tabStep, num: 0 })
          if (setDoneFlag) {
            this.$setTabDone(this.tabStep, true )
          }
        }
      })
    },
    updateLegalStatus ({typeCode}) {
      this.$emit('update-legal-status', {typeCode})
    }
  }

}
</script>
